export const DROP_DOWN_LIST_PRODUCT_TYPE = [
  { item_id: 1, item_text: 'Course' },
  { item_id: 2, item_text: 'Audio Book' },
  { item_id: 3, item_text: 'Video' },
  { item_id: 4, item_text: 'Book' },
];

export const DROP_DOWN_SETTING_PRODDUCT_TYPE = {
  idField: 'item_id',
  textField: 'item_text',
};
export const DROP_DOWN_LIST_BOOK_TYPE = [
  { item_id: 1, item_text: 'Normal' },
  { item_id: 2, item_text: 'Mini' },
  { item_id: 3, item_text: 'Maxi' },
  { item_id: 4, item_text: 'Licensed' },
];
export const DROP_DOWN_SETTING_BOOKTYPE = {
  idField: 'item_id',
  textField: 'item_text',
};
export const SELECT_TYPE_DROP_DOWN_OPTIONS = [
  'less than',
  'greater than',
  'equal to',
  'not equal to',
];

export const SELECT_STATUS_TYPE_DROP_DOWN_OPTIONS = [
  'not equal to',
  'not in',
  'equal to',
  'in',
];

export const DEFAULT_SELECTED_STATUS = [
  'AE_Assigned',
  'Cancelled',
  'Expired',
  'Published',
  'Terminated',
  'Removed_From_Sale',
  'Committed',
  'Inactive',
  'Submitted Proposal',
  'New Proposal',
  'Draft',
];

export const DEFAULT_SELECTED_OPTION_TYPE = 'not in';

export const DROP_DOWN_AUTHOR_TYPE = ['Primary Author', 'Co Author'];

export const DEFAULT_SELECTED_AUTHOR_TYPE = ['Primary Author', 'Co Author'];

export const DROP_DOWN_NETSUITE_ID_TYPE = ['Empty', 'Not Empty'];

export const DEFAULT_NETSUITE_ID_TYPE = ['Not Empty'];

export const DEFAULT_SELECTED_OPTION_TYPE_TOTAL_ROYALTY_PRODUCT = 'equal to';

export const DEFAULT_SELECTED_STATUS_TOTAL_ROYALTY_PRODUCT = ['Published'];

export const DEFAULT_SELECTED_STATUS_TITLE_MASTER = [];
export const DEFAULT_CONTRACT_SELECTED_STATUS_TOTAL_ROYALTY_PRODUCT = [
  'contracted',
];

export const DEFAULT_CONTRACT_SELECTED_STATUS_ROYALTY_V1 = [];

export const DEFAULT_SELECTED_OPTION_TYPE_ROYALTY_V1 = '';

export const NEW_DROP_DOWN_LIST_BOOK_TYPE = [
  { item_id: 1, item_text: 'Normal' },
  { item_id: 2, item_text: 'Mini' },
  { item_id: 3, item_text: 'Maxi' },
  { item_id: 4, item_text: 'Licensed' },
  { item_id: 5, item_text: 'VideoFTM' },
  { item_id: 6, item_text: 'Scripted' },
  { item_id: 7, item_text: 'Video_Leaning_Path' },
  { item_id: 8, item_text: 'elearning' },
  { item_id: 9, item_text: 'Unscripted' },
  { item_id: 10, item_text: 'Instant' },
  { item_id: 11, item_text: 'CWBookEntries' },
  { item_id: 12, item_text: 'Courseware' },
  { item_id: 13, item_text: 'LIVE' },
  { item_id: 14, item_text: 'Book to Audio' },
  { item_id: 15, item_text: 'Curated_Book' },
  { item_id: 16, item_text: 'Integrated_Course' },
  { item_id: 17, item_text: 'Workshop' },
  { item_id: 18, item_text: 'Video_to_Book' },
  { item_id: 19, item_text: 'Report' },
  { item_id: 20, item_text: 'Nano' },
  { item_id: 21, item_text: 'NormalPCC' },
  { item_id: 22, item_text: 'Book_to_Video' },
  { item_id: 23, item_text: 'Translation' },
  { item_id: 24, item_text: 'Curated Book' },
  { item_id: 25, item_text: 'Lite' },
  { item_id: 26, item_text: 'Snackable' },
  { item_id: 27, item_text: 'Conferences' },
];

export const DEFAULT_DROP_DOWN_PISTATUS = [
  'Announce',
  'Announceable',
  'Announced',
  'CME_Approved',
  'CME_Assistance_Requested',
  'InProgress',
  'Not_Published',
  'Proofed',
  'Publish_Title',
  'Published',
  'ReadyforAnnouncement',
  'Ready_for_Announcement_Update',
  'ReadyforMarketing',
  'Readyforproofing',
  'ReadyforPublishing',
  'ReAnnounce',
  'ReAnnounceable',
  'ReAnnounced',
  'WaitingforApproval',
  'Cancelled',
  'Cover_Text_Initiated',
  'Cover_Text_Complete',
  'ReAnnounce_Title',
];

export const SELECT_TYPE_DROP_DOWN_OPTIONS_EQUAL_NOT_EQUAL = [
  'equal to',
  'not equal to',
];

export const SELECT_USER_ID_TYPE_DROP_DOWN_OPTIONS = [
  'current user',
  'ignore',
  'not equal to',
  'not in',
  'equal to',
  'in',
];

export const DEFAULT_AUTHOR_INFO_STATUSES = [
  'Final_Uploaded',
  'Contracted',
  'In Development',
  'Clubbing',
  'In Production',
  'Uploading',
  'LS_Link_Approved',
  'Printers_File_TE_Final_Checks',
  'Dev Handover Accepted',
  'Handover_to_Production',
  'Printers_File_LC_Final_Checks'
];

export const DEFAULT_CHAPTERWISE_TITLES_STATUSES = [
  'QC',
  'Clubbing',
  'Final_Uploaded',
  'Contracted',
  'In Development',
  'Uploading',
  'In Production',
  'LS_Link_Approved',
  'Printers_File_TE_Final_Checks',
  'Dev Handover Accepted',
  'Handover_to_Production',
  'Printers_File_LC_Final_Checks'
];